import classNames from 'classnames';
import {
  InfoMessageBlock,
  PartialWidthContainer,
  SubscriptionStatus,
  Txt,
  View,
} from 'components';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useProperties } from 'state';
import styles from './SubscriptionHome.module.scss';

/**
 * SubscriptionHome
 *
 * @return {JSX.Element}
 */
const SubscriptionHome = ({ className }) => {
  const propertiesState = useProperties();
  const navigate = useNavigate();

  const handlePropertiesClick = () => navigate('../properties');

  return (
    <PartialWidthContainer
      className={classNames(
        styles.SubscriptionHome,
        className,
        SubscriptionHome.displayName
      )}
      column
      gap
      small
    >
      <Helmet title="Subscription" />
      <SubscriptionStatus />
      <InfoMessageBlock
        onClick={handlePropertiesClick}
        captionAsCaption
        caption="PROPERTIES"
        title="In Portfolio"
        description="The number of properties in your portfolio dictates your monthly subscription amount."
        customContentRight={
          <View className={styles.PropertiesCount}>
            <Txt xxx bold>
              {propertiesState.data.length}
            </Txt>
          </View>
        }
      />
    </PartialWidthContainer>
  );
};

SubscriptionHome.displayName = 'SubscriptionHome';

export default observer(SubscriptionHome);
